import React, { useEffect, useState } from 'react';
import { EnrollableCourse } from '@/services/PagesServices/OrganizationMemberActivityService';

interface Props {
  userId: string;
  enrolling: boolean;
  fetchEnrollable: (userId: string, search?: string) => Promise<EnrollableCourse[]>;
  onConfirm: (courseId: number) => void;
  onClose: () => void;
}

const EnrollCourseModal: React.FC<Props> = ({ userId, enrolling, fetchEnrollable, onConfirm, onClose }) => {
  const [courses, setCourses] = useState<EnrollableCourse[]>([]);
  const [selected, setSelected] = useState<number | ''>('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const body = document.body;
    const prev = body.style.overflow;
    body.style.overflow = 'hidden';
    const escHandler = (e: KeyboardEvent) => { if (e.key === 'Escape') onClose(); };
    window.addEventListener('keydown', escHandler);
    return () => {
      body.style.overflow = prev;
      window.removeEventListener('keydown', escHandler);
    };
  }, [onClose]);

  useEffect(() => {
    let active = true;
    setLoading(true);
    fetchEnrollable(userId).then((list) => {
      if (active) {
        setCourses(list);
        setLoading(false);
      }
    });
    return () => { active = false; };
  }, [userId, fetchEnrollable]);

  const handleSubmit = () => {
    if (typeof selected === 'number') onConfirm(selected);
  };

  return (
    <div className="omact-modal-overlay" onClick={onClose}>
      <div className="omact-modal" onClick={(e) => e.stopPropagation()}>
        <h2>Enroll in course</h2>
        <label htmlFor="omact-enroll-course">Course</label>
        <select
          id="omact-enroll-course"
          value={selected}
          onChange={(e) => setSelected(e.target.value ? Number(e.target.value) : '')}
          disabled={loading || enrolling}
        >
          <option value="">{loading ? 'Loading…' : courses.length === 0 ? 'No courses available' : 'Select a course'}</option>
          {courses.map((c) => (
            <option key={c.id} value={c.id}>{c.title}</option>
          ))}
        </select>
        <div className="omact-modal-actions">
          <button className="omact-btn-secondary" onClick={onClose} disabled={enrolling}>Cancel</button>
          <button
            className="omact-btn-primary"
            onClick={handleSubmit}
            disabled={enrolling || selected === '' || loading}
          >
            {enrolling ? 'Enrolling…' : 'Enroll'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default EnrollCourseModal;
